const MAJOR_HIGHWAY_TYPES = [
  "living_street",
  "motorway",
  "motorway_link",
  "primary",
  "primary_link",
  "residential",
  "road",
  "secondary",
  "secondary_link",
  "tertiary",
  "tertiary_link",
  "track",
  "trunk",
  "trunk_link",
  "unclassified",
  "construction",
];
const MINOR_HIGHWAY_TYPES = [
  "bridleway",
  "cycleway",
  "footway",
  "path",
  "pedestrian",
  "service",
  "steps",
  "track",
  "road",
];
export const NAVIGABILITY_HIGHWAY_TYPES =
  MAJOR_HIGHWAY_TYPES + MINOR_HIGHWAY_TYPES;
export const ONEWAY_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES + MINOR_HIGHWAY_TYPES;
export const CURVATURE_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
export const GRADIENT_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
export const DUAL_CARRIAGEWAY_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
export const EMISSION_REGULATION_HIGHWAY_TYPES =
  MAJOR_HIGHWAY_TYPES + ["pedestrian", "service", "track"];
export const RAMP_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
export const CONTROLLED_ACCESS_HIGHWAY_TYPES = MAJOR_HIGHWAY_TYPES;
